import { getNonce } from './nonce'
;(() => {
  // Evita múltiplas aplicações (HMR, imports duplicados)
  if ((window as any).__nonceCreateShimApplied) return
  ;(window as any).__nonceCreateShimApplied = true

  const NONCE = getNonce()

  const isNonceTarget = (el: Element | null): boolean => {
    if (!el || !el.tagName) return false
    const tag = el.tagName
    return (
      tag === 'STYLE' ||
      tag === 'SCRIPT' ||
      (tag === 'LINK' && (el as HTMLLinkElement).rel === 'stylesheet')
    )
  }

  const setNonce = (el: Element | null) => {
    if (el && isNonceTarget(el) && !el.getAttribute('nonce')) {
      try {
        el.setAttribute('nonce', NONCE)
      } catch (_e) {}
    }
  }

  const collectTargets = (input: any): Element[] => {
    const found: Element[] = []

    const visit = (node: any) => {
      if (!node) return

      // Elemento único
      if (node.nodeType === Node.ELEMENT_NODE) {
        const el = node as Element
        if (isNonceTarget(el)) found.push(el)
        // Também colete descendentes relevantes, caso seja um fragmento grande
        el.querySelectorAll?.('style,link[rel="stylesheet"],script').forEach(
          n => {
            if (n instanceof Element && isNonceTarget(n)) found.push(n)
          }
        )
        return
      }

      // Fragmento de documento
      if (node.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
        ;(node as DocumentFragment)
          .querySelectorAll?.('style,link[rel="stylesheet"],script')
          .forEach(n => {
            if (n instanceof Element && isNonceTarget(n)) found.push(n)
          })
        return
      }

      // Listas ou iteráveis (append/prepend podem receber vários)
      if (
        Array.isArray(node) ||
        (node && typeof node[Symbol.iterator] === 'function')
      ) {
        for (const n of node) visit(n)
      }
    }

    visit(input)
    return found
  }

  // 1) Criação: createElement
  const originalCreateElement = document.createElement.bind(document)
  // @ts-ignore - sobrescrevendo createElement de forma controlada
  document.createElement = function (tagName: any, options?: any) {
    const element = originalCreateElement(tagName as any, options as any)
    const tag = String(tagName).toLowerCase()
    if (tag === 'style' || tag === 'script') {
      setNonce(element)
    }
    // <link> pode não ter rel ainda; será coberto na inserção
    return element
  }

  // 2) Criação: createElementNS
  const originalCreateElementNS = document.createElementNS.bind(document)
  // @ts-ignore - sobrescrevendo createElementNS
  document.createElementNS = function (
    ns: any,
    qualifiedName: any,
    options?: any
  ) {
    const element = originalCreateElementNS(
      ns as any,
      qualifiedName as any,
      options as any
    )
    const tag = String(qualifiedName).toLowerCase()
    if (tag === 'style' || tag === 'script') {
      setNonce(element)
    }
    return element
  }

  // 3) Inserção: appendChild / insertBefore / replaceChild em Node.prototype
  ;(['appendChild', 'insertBefore', 'replaceChild'] as const).forEach(
    method => {
      const original = (Node.prototype as any)[method]
      ;(Node.prototype as any)[method] = function (...args: any[]) {
        try {
          if (method === 'replaceChild') {
            const newNode = args[0]
            for (const el of collectTargets(newNode)) setNonce(el)
          } else {
            const node = args[0]
            for (const el of collectTargets(node)) setNonce(el)
          }
        } catch (_e) {}
        return original.apply(this, args)
      }
    }
  )

  // 4) Inserção múltipla: append / prepend em Element, Document, DocumentFragment
  const patchAppendPrepend = (prototype: any) => {
    ;(['append', 'prepend'] as const).forEach(method => {
      const original = prototype[method]
      if (typeof original === 'function') {
        prototype[method] = function (...nodes: any[]) {
          try {
            for (const el of collectTargets(nodes)) setNonce(el)
          } catch (_e) {}
          return original.apply(this, nodes)
        }
      }
    })
  }

  patchAppendPrepend(Element.prototype as any)
  patchAppendPrepend(Document.prototype as any)
  patchAppendPrepend(DocumentFragment.prototype as any)
})()
